import { ArrowLeftIcon } from 'assets/icons';
import { BREAKPOINTS } from 'constants/common';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const PreviousNav = ({ url, style }: { url: string; style?: React.CSSProperties }) => {
  return (
    <PreviousNavWrap to={url} style={style}>
      <ArrowLeftIcon />
      Previous step
    </PreviousNavWrap>
  );
};

export const PreviousNavWrap = styled(NavLink)`
  display: flex;
  position: relative;
  align-items: center;
  color: var(--Primary-P500, #4f31ff);

  /* Text sm/Semibold */
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  text-decoration: none;
  margin-left: 32px;

  svg {
    margin-right: 8px;
  }

  @media (max-width: ${BREAKPOINTS.tablet}px) {
    margin-left: 0px;
  }
`;
